import axios from 'axios';
import { BUSINESS_API_BASE_URL } from './endpoint';

const getWorkers = async (businessId, serviceId) => {
    const params = {};
    
    if (serviceId) {
        params.service_id = serviceId;
    }
    
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/${businessId}/workers/approved`, {
        params,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}
export { getWorkers }